<template>
  <div>
    <el-form ref="form" :model="form" class="form_flex">
      <el-form-item prop="customerName">
        <HouseSelect
          ref="houseSelectRef"
          @setHouseId="setHouseId"
          :placeholder="'请输入楼盘名'"
        />
      </el-form-item>
      <el-form-item prop="userName">
        <UserSelect
          ref="userSelectRef"
          @setUserId="setUserId"
          :placeholder="'请输入用户名'"
        />
      </el-form-item>

      <el-form-item class="btn">
        <el-button @click="onSearch" icon="el-icon-search" size="small"
          >查询</el-button
        >
        <el-button size="small" icon="el-icon-plus" @click="resetForm('form')"
          >清空</el-button
        >
        <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
          >刷新</el-button
        >
        <el-button
          size="small"
          icon="el-icon-plus"
          @click="onAdd"
          type="primary"
          v-if="roleList[path].includes('_Add')"
          >新增</el-button
        >
      </el-form-item>
    </el-form>

    <Form ref="setForm" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HouseSelect from './houseSelect.vue';
import UserSelect from './userSelect.vue';
import Form from './form';
export default {
  name: 'AllotSearchBar',
  components: {
    HouseSelect,
    UserSelect,
    Form,
  },
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  data() {
    return {
      // 表单内容
      path: '',
      form: {
        houseId: '',
        custUserId: '',
      },
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  methods: {
    // 搜索，触发父组件请求数据的方法
    onSearch() {
      this.$emit('search', this.form);
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    onAdd() {
      this.$emit('openForm', '新增客服');
    },

    setHouseId(val) {
      this.form.houseId = val;
    },

    setUserId(val) {
      this.form.custUserId = val;
    },
    // 清空表单
    resetForm(formName) {
      // this.hosueName = '';
      // this.userName = '';
      this.setHouseId('');
      this.setUserId('');
      this.$refs.houseSelectRef.houseName = '';
      this.$refs.userSelectRef.userName = '';
      this.$refs[formName].resetFields();
      this.onSearch();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
